import { useState } from "react";
import { useDispatch } from "react-redux";
import { toast } from "sonner";
import { CheckIcon } from "lucide-react";

import { LoadboardModal, LoadModalDetails, ModalDisclaimer } from "@/components/dataPages/loadboard";
import { TranslatedText, CurrencyText } from "@/components/common/text";
import { API } from "@/services/API";
import { getLoadId } from "@/utils/load";
import { markLoadAsUnavailable } from "@/state/loadSearchSlice";
import { fetchAllOffers } from "@/state/offersSlice";
import { useOffersRefresh } from "@/contexts/OffersRefreshContext";

export const LoadboardBookingModal = ({ load, open, onOpenChange, isDisabled }) => {
    const dispatch = useDispatch();
    const resetOffersInterval = useOffersRefresh();
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const idToShow = load.externalLoadId || getLoadId(load.uniqueId);

    const handleConfirmBooking = () => {
        if (!isLoading && !load.isUnavailable) {
            setIsLoading(true);
            API.post("/parade/book", {
                loadUniqueId: load.uniqueId,
                offerRate: load.offerRate,
            })
                .then(() => {
                    onOpenChange(false);
                    setError(null);
                    dispatch(markLoadAsUnavailable(load.uniqueId));
                    if (resetOffersInterval) {
                        resetOffersInterval();
                    }
                    dispatch(fetchAllOffers({ isAutoRefresh: true }));
                    toast.info(`Load ${idToShow} booked successfully!\nAwaiting broker response.`);
                })
                .catch((err) => {
                    console.error("Failed to book loads", err);
                    setError(typeof err === "string" ? err : "Booking failed.");
                })
                .finally(() => {
                    setIsLoading(false);
                });
        }
    };

    return (
        <LoadboardModal
            title="Confirm booking"
            buttonClassName="bg-cm-accent-button text-cm-p-text-primary w-full h-11 rounded-[58px] disabled:opacity-30"
            buttonDisabled={isDisabled}
            buttonChildren={
                <span className="font-medium">
                    <TranslatedText text="Book for" />
                    <CurrencyText className="ml-1 text-sm/[22px]" num={load.offerRate} round />
                </span>
            }
            open={open}
            onOpenChange={onOpenChange}
        >
            <LoadModalDetails load={load} />
            <ModalDisclaimer text="Disclaimer message to think of if needed to be added here, or instruction what's gonna happen after Confirm." />
            <button
                type="button"
                onClick={handleConfirmBooking}
                disabled={isLoading}
                className="mt-3 bg-cm-accent-button text-cm-p-text-primary w-full h-11 rounded-lg disabled:opacity-30 text-sm/[22px] font-medium inline-flex items-center justify-center gap-1"
            >
                <TranslatedText text="Confirm booking" />
                <CheckIcon className="size-4" />
            </button>
            {error ? <div className="text-cm-error pt-3">{error}</div> : null}
        </LoadboardModal>
    );
};
